module.exports = __webpack_public_path__ + "img/weatherBc2.1641520899224.png";